module.exports = __webpack_public_path__ + "img/81w.c60d454.jpg";